import React, { useState, useEffect, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { Grid, Divider, Typography, Skeleton, TextField, Tooltip } from "@mui/material";
import {
  Container,
  CalendarLikeContainer,
  CalendarLikeHeader,
  CalendarLikeBody,
  CalendarLikeAction,
  ClockInOutButton,
  ClockInOutContainer,
  LiveClockContainer,
} from "./styles";
import { EmployeePresenceAndLeavesSummaryDTO } from "../../../../models/employee-presence-and-leaves-summary/employee-presence-and-leaves-summary-dto";

import { CalendarPlusIcon } from "../../../../assets/icons";
import { saveTnAClockings } from "../../../../services/tna-clockings/tna-clockings-api.service";
import { EmployeeDTO, EmployeeRef } from "../../../../models/employees";
import { TnAConfigRef, TnADateTime } from "../../../../models/tna";

import { HOW_TO_REPORT_TIME, TNA_CLOCKING_TYPES } from "../../../../utils/constants/tna-constants";
import { TnAScheduleIntervalRef } from "src/models/tna/tna-schedule-intervals/tna-schedule-interval-ref";
import { ReportWorkedDays } from "src/containers/MyCalendar/ReportWorkedDays/ReportWorkedDays";
import AddEditWorkedHours from "src/containers/MyCalendar/AddEditWorkedHours/AddEditWorkedHours";
import { computeMonthName } from "../../../../utils/time-utils";
import LiveClock from "../../../LiveClock/LiveClock";
import LoadingOverlay from "../../../LoadingOverlay/LoadingOverlay";
import CustomConfirmationChangesDialog from "../../../CustomConfirmationChangesDialog/CustomConfirmationChangesDialog";
import { fixHourFormat } from "../../../../utils/fix-hour-format";
import DayDataSummary from "./DayDataSummary";
import { diffInScheduleAndClocking } from "src/containers/MyClockings/utils";
import { TnADayDataDTO } from "src/models/tna/tna-data/tna-day-data-dto";
import { TnADayDataRef } from "src/models/tna/tna-data/tna-day-data-ref";
import {
  TnALocationCodesApiService,
  loadClockingLocationCodes,
} from "src/services/tna-location-codes/tna-location-codes-api.service";
import { TNA_TRACK_LOCATION_TYPES } from "src/utils/constants/track-location-constants";
import AutocompleteDropdown from "../../../../reusable-components/AutocompleteDropdown/AutocompleteDropdown";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { TnALocationCodeDTO } from "../../../../models/tna-location-codes/tna-location-code-dto";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddEditClockingLocation from "../../../AddEditClockingLocation/AddEditClockingLocation";
import { checkLocationMatching } from "../../../AddEditClockingLocation/utils";
import RealTimeClockingButtons from "../../../RealTimeClockingButtons/RealTimeClockingButtons";

const weekDays = ["Monday", "Thuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const { ClockIn, ClockOut } = TNA_CLOCKING_TYPES;

interface State {
  saveLoading: boolean;
  error: string;
  actualTnAConfig: TnAConfigRef | null;
  todayIntervals: TnAScheduleIntervalRef[];
  employee: EmployeeRef | null;
  loading: boolean;
  clockingToSave: {
    date: Date;
    type: "clockIn" | "clockOut";
  } | null;
  isCCCDOpen: boolean;
  isWarningCCCDOpen: boolean;
  hoursBeforeClosestInterval: number | null;
  forPrevDay: boolean;
  tnALocationCodeOrName: string;
  tnALocationCode: TnALocationCodeDTO | null;
  locationWarning: boolean;
  isLocationCCCDOpen: boolean;
}

const MyTimesheetLink = ({
  customSummary,
  loading,
  reloadCustomSummary,
}: {
  customSummary: EmployeePresenceAndLeavesSummaryDTO;
  loading: boolean;
  reloadCustomSummary: () => void;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.my_presence_and_leaves.my_timesheet";
  const tRPActions = "components.my_clockings";
  const theme = useTheme();
  const [state, setState] = useState<State>({
    saveLoading: false,
    error: "",
    actualTnAConfig: null,
    todayIntervals: [],
    employee: null,
    loading: false,
    clockingToSave: null,
    isCCCDOpen: false,
    isWarningCCCDOpen: false,
    hoursBeforeClosestInterval: 0,
    forPrevDay: false,
    tnALocationCodeOrName: "",
    tnALocationCode: null,
    locationWarning: false,
    isLocationCCCDOpen: false,
  });

  //#region save clocking
  // const handleSaveTnAClocking = async (
  //   clockingType: "clockIn" | "clockOut",
  //   date: Date,
  //   forPrevDay: boolean = false
  // ) => {
  //   let matchingLocation: TnALocationCodeDTO | undefined = undefined;
  //   if (
  //     state.actualTnAConfig?.tnATrackLocation?.id === TNA_TRACK_LOCATION_TYPES.ALLOW_ANY_WITH_FLAG &&
  //     !matchingLocation
  //   ) {
  //     const { items } = await loadClockingLocationCodes({
  //       employeeId: customSummary.tnAEmployeeConfig?.employee?.id!,
  //       codeOrName: state.tnALocationCodeOrName.toLowerCase(),
  //     });
  //     matchingLocation = items[0] ?? undefined;

  //     if (!matchingLocation) {
  //       if (!state.locationWarning) {
  //         setState((prev) => ({
  //           ...prev,
  //           locationWarning: true,
  //         }));
  //         return;
  //       }
  //     }
  //   }

  //   setState((state) => ({ ...state, saveLoading: true }));

  //   try {
  //     const { error } = await saveTnAClockings(
  //       state.employee as EmployeeDTO,
  //       clockingType === "clockIn" ? ClockIn.id : ClockOut.id,
  //       TnADateTime.FromDate(date),
  //       matchingLocation || state.tnALocationCode || null,
  //       state.tnALocationCodeOrName ? state.tnALocationCodeOrName : "",
  //       forPrevDay
  //     );

  //     if (!!error) {
  //       setState((state) => ({ ...state, error }));
  //     } else {
  //       setState((state) => ({
  //         ...state,
  //         isCCCDOpen: false,
  //         clockingToSave: null,
  //         isWarningCCCDOpen: false,
  //         hoursBeforeClosestInterval: 0,
  //         forPrevDay: false,
  //       }));
  //       reloadCustomSummary();
  //       // await loadMyClockings();
  //       // if (!!clockingChanged) {
  //       //   clockingChanged();
  //       // }
  //     }
  //   } catch (error) {
  //     setState((state) => ({
  //       ...state,
  //       error: error as string,
  //     }));
  //   } finally {
  //     setState((state) => ({
  //       ...state,
  //       saveLoading: false,
  //     }));
  //   }
  // };
  //#endregion

  //#region with zero date number
  const withZeroDateNumber = (number: number) => {
    if (number === 0) return "00";

    return number < 10 ? `0${number}` : `${number}`;
  };
  //#endregion

  useEffect(() => {
    setState(() => ({
      ...state,
      actualTnAConfig:
        customSummary.tnAEmployeeConfig?.tnAConfig ??
        customSummary.tnAEmployeeConfig?.employeeGroupTnAConfig ??
        customSummary.tnAEmployeeConfig?.legalEntityTnAConfig ??
        customSummary.tnAEmployeeConfig?.companyAccountTnAConfig ??
        customSummary.tnAEmployeeConfig?.legislationTnAConfig ??
        customSummary.tnAEmployeeConfig?.allLegislationsTnAConfig ??
        null,
      employee: customSummary.tnAEmployeeConfig?.employee ?? null,
    }));
  }, [customSummary]);

  //#region check track location
  // const checkTrackLocation = useCallback(
  //   (clockingType: "clockIn" | "clockOut", date: Date = new Date()) => {
  //     if (
  //       state.actualTnAConfig?.tnATrackLocation &&
  //       state.actualTnAConfig?.tnATrackLocation?.id !== TNA_TRACK_LOCATION_TYPES.NOT_NEEDED
  //     ) {
  //       setState((prev) => ({
  //         ...prev,
  //         isLocationCCCDOpen: true,
  //         clockingToSave: {
  //           date: date,
  //           type: clockingType,
  //         },
  //         tnALocationCodeOrName: "",
  //         tnALocationCode: null,
  //         locationWarning: false,
  //       }));
  //       return;
  //     } else {
  //       setState((state) => ({
  //         ...state,
  //         clockingToSave: {
  //           date: date,
  //           type: clockingType,
  //         },
  //         isCCCDOpen: true,
  //       }));
  //     }
  //   },
  //   [state.actualTnAConfig?.tnATrackLocation?.id]
  // );
  //#endregion

  // const renderLocationInput = () => {
  //   const locationTrackingType = state.actualTnAConfig?.tnATrackLocation?.id;

  //   switch (locationTrackingType) {
  //     case TNA_TRACK_LOCATION_TYPES.ALLOW_ANY_LOCATION:
  //       return (
  //         <TextField
  //           sx={{ width: "100%", mt: 2 }}
  //           label={`${t(`${tRPActions}.location_code`)}`}
  //           value={state.tnALocationCodeOrName}
  //           onChange={(e) => {
  //             const value = e.target.value;
  //             setState((prev) => ({
  //               ...prev,
  //               tnALocationCodeOrName: value,
  //               tnALocationCode: null,
  //               locationWarning: false,
  //             }));
  //           }}
  //         />
  //       );

  //     case TNA_TRACK_LOCATION_TYPES.ALLOW_ANY_WITH_FLAG:
  //       return (
  //         <Grid sx={{ gap: 2, display: "flex", width: "100%", flexDirection: "row", alignItems: "center" }}>
  //           <TextField
  //             sx={{ width: "100%", mt: 2 }}
  //             label={`${t(`${tRPActions}.location_code`)}`}
  //             value={state.tnALocationCodeOrName}
  //             onChange={async (e) => {
  //               const value = e.target.value;
  //               setState((prev) => ({
  //                 ...prev,
  //                 tnALocationCodeOrName: value,
  //                 tnALocationCode: null,
  //                 locationWarning: false,
  //               }));
  //             }}
  //           />
  //           {state.tnALocationCode && (
  //             <Tooltip title={t(`${tRPActions}.location_found_in_predefined_list`)}>
  //               <span>
  //                 <FontAwesomeIcon
  //                   icon={faInfoCircle}
  //                   color="#4caf50"
  //                   style={{ marginLeft: "8px" }}
  //                 />
  //               </span>
  //             </Tooltip>
  //           )}
  //         </Grid>
  //       );

  //     case TNA_TRACK_LOCATION_TYPES.ALLOW_ONLY_PREDEFINED:
  //       return (
  //         <AutocompleteDropdown
  //           labelKey={`${tRPActions}.location`}
  //           field="tnALocationCode"
  //           handleChange={(field, value) =>
  //             setState((prev) => ({
  //               ...prev,
  //               tnALocationCode: value,
  //               locationWarning: false,
  //             }))
  //           }
  //           serviceApi={new TnALocationCodesApiService()}
  //           required={true}
  //           selectedValue={state.tnALocationCode}
  //           sxProps={{ width: "100%", mt: 2 }}
  //         />
  //       );

  //     default:
  //       return null;
  //   }
  // };

  return (
    <>
      <Container>
        <Grid>
          <Typography style={{ color: theme.palette.primary.light }}>{`${t(`${tRP}.title`)}`}</Typography>
        </Grid>
        {loading ? (
          <Skeleton
            variant="rounded"
            width="100px"
            height={"100px"}
            style={{ marginLeft: "5px" }}
          />
        ) : (
          state.employee && (
            <Grid
              onClick={(e) => e.preventDefault()}
              style={{
                cursor: "default",
                position: "relative",
              }}
            >
              <LoadingOverlay
                loading={state.saveLoading}
                spinnerSize="2x"
                isSpinnerPositionAbsolute
                customSpinnerStyle={{
                  top: 50,
                  left: 0,
                }}
              >
                {state.actualTnAConfig?.how2ReportTime?.id === HOW_TO_REPORT_TIME.ClockingManually.id ? (
                  <ClockInOutContainer>
                    <Grid>
                      <Grid style={{ position: "absolute", right: "1px", top: "1px" }}>
                        {customSummary.tnAEmployeeDayData && (
                          <DayDataSummary
                            dayData={customSummary.tnAEmployeeDayData}
                            tnaConfig={state.actualTnAConfig}
                          />
                        )}
                      </Grid>
                      <LiveClockContainer>
                        <LiveClock />
                      </LiveClockContainer>
                      <Grid
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        <RealTimeClockingButtons
                          employee={state.employee}
                          forPrevDay={state.forPrevDay}
                          tnATrackLocationId={state.actualTnAConfig?.tnATrackLocation?.id}
                        />

                        {/* <ClockInOutButton
                          clockin={true}
                          variant="contained"
                          disabled={state.loading}
                          onClick={() => {
                            checkTrackLocation("clockIn", new Date());
                          }}
                          // setState((state) => ({
                          //   ...state,
                          //   clockingToSave: {
                          //     date: new Date(),
                          //     type: "clockIn",
                          //   },
                          //   isCCCDOpen: true,
                          // }));
                          // handleSaveTnAClocking("clockIn")
                          // }}
                        >
                          {t(`${tRPActions}.clock_in`)}
                        </ClockInOutButton>

                        <ClockInOutButton
                          clockin={false}
                          variant="contained"
                          disabled={state.loading}
                          onClick={() => {
                            checkTrackLocation("clockOut", new Date());

                            // setState((state) => ({
                            //   ...state,
                            //   clockingToSave: {
                            //     date: new Date(),
                            //     type: "clockOut",
                            //   },
                            //   isCCCDOpen: true,
                            // }));
                            // handleSaveTnAClocking("clockOut")
                          }}
                        >
                          {t(`${tRPActions}.clock_out`)}
                        </ClockInOutButton> */}
                      </Grid>
                    </Grid>
                  </ClockInOutContainer>
                ) : state.actualTnAConfig?.how2ReportTime?.id === HOW_TO_REPORT_TIME.AutoClockingBySytem.id ||
                  state.actualTnAConfig?.how2ReportTime?.id === HOW_TO_REPORT_TIME.AutoWorkedHours.id ||
                  state.actualTnAConfig?.how2ReportTime?.id === HOW_TO_REPORT_TIME.AutoWorkedDays.id ? (
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      backgroundColor: theme.palette.background.paper,
                      borderRadius: "12px",
                      padding: "8px",
                    }}
                  >
                    <Typography style={{ color: theme.palette.text.primary }}>
                      <b>{state.actualTnAConfig?.schedule?.code}</b>
                    </Typography>

                    {Number(state.actualTnAConfig?.schedule?.intervals.filter((interval) => interval)?.length) > 0 ? (
                      state.actualTnAConfig?.schedule?.intervals
                        .filter((interval) => interval.weekDay === new Date().getDay())
                        .sort((firstInterval, secondInterval) => firstInterval.startHour - secondInterval.startHour)
                        .map((interval) => (
                          <Typography key={interval.id}>
                            {withZeroDateNumber(interval.startHour)}:{withZeroDateNumber(interval.startMinute)} -{" "}
                            {withZeroDateNumber(interval.endHour)}:{withZeroDateNumber(interval.endMinute)}
                          </Typography>
                        ))
                    ) : (
                      <>{`${t(`${tRP}.no_interval`)}`} </>
                    )}
                  </Grid>
                ) : state.actualTnAConfig?.how2ReportTime?.id === HOW_TO_REPORT_TIME.ManualWorkedDays.id ? (
                  <CalendarLikeContainer>
                    <CalendarLikeHeader>
                      {customSummary.tnAEmployeeDayData && (
                        <Grid style={{ position: "absolute", top: "1px", right: "1px" }}>
                          <DayDataSummary
                            dayData={customSummary.tnAEmployeeDayData}
                            tnaConfig={state.actualTnAConfig}
                          />
                        </Grid>
                      )}
                      <Typography>{computeMonthName(new Date().getMonth())}</Typography>
                    </CalendarLikeHeader>
                    <CalendarLikeBody>
                      <Typography variant="h5">
                        <b>{new Date().getDate()}</b>
                      </Typography>
                      <Divider
                        flexItem
                        orientation="vertical"
                      />
                      <ReportWorkedDays
                        id={""}
                        employee={state.employee}
                        tnAMonth={{
                          year: new Date().getFullYear(),
                          month: new Date().getMonth(),
                        }}
                        dates={[new Date().getDate()]}
                        handleNotifyParent={reloadCustomSummary}
                        dayData={customSummary.tnAEmployeeDayData ? [customSummary.tnAEmployeeDayData] : []}
                      >
                        <CalendarLikeAction>
                          <CalendarPlusIcon />
                        </CalendarLikeAction>
                      </ReportWorkedDays>
                    </CalendarLikeBody>
                  </CalendarLikeContainer>
                ) : state.actualTnAConfig?.how2ReportTime?.id === HOW_TO_REPORT_TIME.ManualWorkedHours.id ? (
                  <>
                    <CalendarLikeContainer>
                      <CalendarLikeHeader>
                        {customSummary.tnAEmployeeDayData && (
                          <Grid style={{ position: "absolute", top: "1px", right: "1px" }}>
                            <DayDataSummary
                              dayData={customSummary.tnAEmployeeDayData}
                              tnaConfig={state.actualTnAConfig}
                            />
                          </Grid>
                        )}
                        <Typography>{computeMonthName(new Date().getMonth())}</Typography>
                      </CalendarLikeHeader>
                      <CalendarLikeBody>
                        <Typography variant="h5">
                          <b>{new Date().getDate()}</b>
                        </Typography>
                        <Divider
                          flexItem
                          orientation="vertical"
                        />
                        <AddEditWorkedHours
                          employee={state.employee}
                          tnADate={{
                            year: new Date().getFullYear(),
                            month: new Date().getMonth() + 1,
                            day: new Date().getDate(),
                          }}
                          notifyParent={reloadCustomSummary}
                          buttonType="icon"
                          dayData={[customSummary.tnAEmployeeDayData as TnADayDataDTO]}
                        />
                      </CalendarLikeBody>
                    </CalendarLikeContainer>
                  </>
                ) : (
                  <></>
                )}
              </LoadingOverlay>
            </Grid>
          )
        )}
      </Container>
      {/* <CustomConfirmationChangesDialog
        open={state.isCCCDOpen}
        loading={state.saveLoading}
        title={"Save clocking"}
        handleCancel={() => {
          setState((state) => ({
            ...state,
            isCCCDOpen: false,
            clockingToSave: null,
          }));
        }}
        actionsAndHandlers={
          !customSummary?.tnAEmployeeDayData
            ? [
                {
                  action: "Yes",
                  buttonVariant: "contained",
                  handler: () => {
                    state.clockingToSave?.type &&
                      state.clockingToSave?.date &&
                      handleSaveTnAClocking(state.clockingToSave.type, state.clockingToSave.date);
                  },
                },
              ]
            : customSummary?.tnAEmployeeDayData?.prevDayNightShift
            ? [
                {
                  action: "Save for previous day",
                  buttonVariant: "contained",
                  handler: () => {
                    if (state.clockingToSave && customSummary?.tnAEmployeeDayData) {
                      const differenceInClockingsAndSchedule = diffInScheduleAndClocking(
                        state.clockingToSave.date,
                        [customSummary.tnAEmployeeDayData as TnADayDataRef],
                        true
                      );

                      differenceInClockingsAndSchedule === null || differenceInClockingsAndSchedule > 1
                        ? setState((state) => ({
                            ...state,
                            hoursBeforeClosestInterval: differenceInClockingsAndSchedule,
                            isWarningCCCDOpen: true,
                            forPrevDay: true,
                          }))
                        : handleSaveTnAClocking(state.clockingToSave.type, state.clockingToSave.date, true);
                    }
                  },
                },
                {
                  action: "Yes",
                  buttonVariant: "contained",
                  handler: () => {
                    if (state.clockingToSave && customSummary?.tnAEmployeeDayData) {
                      const differenceInClockingsAndSchedule = diffInScheduleAndClocking(
                        state.clockingToSave.date,
                        [customSummary.tnAEmployeeDayData as TnADayDataRef],
                        false
                      );

                      differenceInClockingsAndSchedule === null || differenceInClockingsAndSchedule > 1
                        ? setState((state) => ({
                            ...state,
                            hoursBeforeClosestInterval: differenceInClockingsAndSchedule,
                            isWarningCCCDOpen: true,
                          }))
                        : handleSaveTnAClocking(state.clockingToSave.type, state.clockingToSave.date);
                    }
                  },
                },
              ]
            : [
                {
                  action: "Yes",
                  buttonVariant: "contained",
                  handler: () => {
                    if (state.clockingToSave && customSummary?.tnAEmployeeDayData) {
                      const differenceInClockingsAndSchedule = diffInScheduleAndClocking(
                        state.clockingToSave.date,
                        [customSummary.tnAEmployeeDayData as TnADayDataDTO],
                        false
                      );

                      differenceInClockingsAndSchedule === null || differenceInClockingsAndSchedule > 1
                        ? setState((state) => ({
                            ...state,
                            hoursBeforeClosestInterval: differenceInClockingsAndSchedule,
                            isWarningCCCDOpen: true,
                          }))
                        : handleSaveTnAClocking(state.clockingToSave.type, state.clockingToSave.date);
                    }
                  },
                },
              ]
        }
      >
        <Typography>
          {!state.clockingToSave ? (
            "No clocking to save"
          ) : (
            <>
              Are you sure you want to save
              <b>{state.clockingToSave.type === "clockIn" ? " Clock in " : " Clock out "}</b> today at{" "}
              <b>
                {fixHourFormat(state.clockingToSave.date.getHours())} :{" "}
                {fixHourFormat(state.clockingToSave?.date.getMinutes())}
              </b>
            </>
          )}
        </Typography>
      </CustomConfirmationChangesDialog> */}

      {/* <CustomConfirmationChangesDialog
        open={state.isWarningCCCDOpen}
        loading={state.loading || state.saveLoading}
        title={"Off expected schedule"}
        handleCancel={() => {
          setState((state) => ({
            ...state,
            isCCCDOpen: false,
            isWarningCCCDOpen: false,
            clockingToSave: null,
            forPrevDay: false,
            hoursBeforeClosestInterval: 0,
          }));
        }}
        actionsAndHandlers={[
          {
            action: "Yes",
            buttonVariant: "contained",
            handler: () => {
              state.clockingToSave &&
                handleSaveTnAClocking(state.clockingToSave.type, state.clockingToSave.date, state.forPrevDay);
            },
          },
        ]}
      >
        <Grid sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Typography>
            {!state.clockingToSave ? (
              "No clocking to save"
            ) : (
              <>
                {state.hoursBeforeClosestInterval === null ? (
                  <>
                    We have noticed that you are reporting presence significantly off expected schedule (no schedule for
                    this day). Do you really want to save{" "}
                    <b>{state.clockingToSave.type === "clockIn" ? " Clock in " : " Clock out "}</b> at{" "}
                    <b>
                      {fixHourFormat(state.clockingToSave.date.getHours())} :{" "}
                      {fixHourFormat(state.clockingToSave?.date.getMinutes())}
                    </b>{" "}
                    ?
                  </>
                ) : (
                  <>
                    <b>{state.clockingToSave.type === "clockIn" ? " Clock in " : " Clock out "}</b> at{" "}
                    <b>
                      {fixHourFormat(state.clockingToSave.date.getHours())} :{" "}
                      {fixHourFormat(state.clockingToSave?.date.getMinutes())}
                    </b>{" "}
                    is <b>{state.hoursBeforeClosestInterval.toFixed(2)}h</b> off schedule. Do you really want to
                    continue?
                  </>
                )}
              </>
            )}
          </Typography>
        </Grid>
      </CustomConfirmationChangesDialog> */}

      {/* {state.actualTnAConfig?.tnATrackLocation &&
        state.actualTnAConfig?.tnATrackLocation.id !== TNA_TRACK_LOCATION_TYPES.NOT_NEEDED && (
          <CustomConfirmationChangesDialog
            open={state.isLocationCCCDOpen}
            loading={state.saveLoading}
            title={!state.locationWarning ? t(`${tRP}.select_location`) : t(`${tRP}.location_confirmation`)}
            handleCancel={() => {
              setState((prev) => ({
                ...prev,
                isLocationCCCDOpen: false,
                locationWarning: false,
                clockingToSave: null,
                tnALocationCode: null,
                tnALocationCodeOrName: "",
              }));
            }}
            actionsAndHandlers={[
              {
                action: t("buttons.save"),
                buttonVariant: "contained",
                disabled: !state.tnALocationCodeOrName && !state.tnALocationCode,
                handler: async () => {
                  if (state.locationWarning) {
                    setState((prev) => ({
                      ...prev,
                      locationWarning: false,
                      isLocationCCCDOpen: false,
                    }));
                  }
                  await handleSaveTnAClocking(
                    state.clockingToSave?.type!,
                    state.clockingToSave?.date!,
                    state.forPrevDay
                  );
                },
              },
            ]}
          >
            <Grid sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {state.actualTnAConfig?.tnATrackLocation &&
                state.actualTnAConfig.tnATrackLocation.id !== TNA_TRACK_LOCATION_TYPES.NOT_NEEDED && (
                  <Grid>
                    {!state.locationWarning && (
                      <Typography>
                        <b>{state?.clockingToSave?.type === "clockIn" ? " Clock in " : " Clock out "}</b> at{" "}
                        <b>
                          {fixHourFormat(state?.clockingToSave?.date?.getHours() ?? 0)} :{" "}
                          {fixHourFormat(state?.clockingToSave?.date?.getMinutes() ?? 0)}
                          {`(${state?.clockingToSave?.date.toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })})`}
                        </b>
                      </Typography>
                    )}
                    {state.locationWarning ? (
                      <Typography>
                        <Trans
                          i18nKey={`${tRP}.location_warning`}
                          values={{ location: state.tnALocationCodeOrName }}
                          components={{
                            bold: <b />,
                          }}
                        />
                      </Typography>
                    ) : (
                      renderLocationInput()
                    )}
                  </Grid>
                )}
            </Grid>
          </CustomConfirmationChangesDialog>
        )} */}
    </>
  );
};
export default MyTimesheetLink;
